import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import SisLoader from "../../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../../widgets/AppToast";
import AddLngCargoCompressorModal from "../../components/CargoCraneCom/AddLngCargoCompressorModal";
import LngCargoCompressorTable from "../../components/CargoCraneCom/LngCargoCompressorRow";

function LngCargoCompressor({ id, onSuccess }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errors, set_errors] = useState({});

  const LIST_API = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", id);
    try {
      post(ApiURL.list_lng_cargo_compressor_details, FORM_DATA).then((res) => {
        if (res?.status === true) {
          setFilteredData(res?.lng_cargo_parameters_data);
        }
      });
    } catch (error) {
      console.error("Error fetching LNG Cargo Compressor list:", error);
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const ADD_API = (data) => {
    setLoader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("lng_name", data?.compressor_name);
      FORM_DATA.append("lng_model", data?.compressor_model);
      FORM_DATA.append("lng_maker", data?.compressor_maker);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.add_lng_cargo_compressor_details, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("LNG Cargo Compressor Details Saved!", "Details Successfully Added!!");
          LIST_API();
          setIsModalOpen(false);
          setLoader(false);
          if (onSuccess) onSuccess();
        } else {
          setLoader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      setLoader(false);
      console.error("Error occurred while adding LNG Cargo Compressor details:", error);
    }
  };

  const UPDATE_API = (data) => {
    setLoader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("lng_name", data?.compressor_name);
      FORM_DATA.append("lng_model", data?.compressor_model);
      FORM_DATA.append("lng_maker", data?.compressor_maker);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.edit_view_lng_cargo_compressor_details, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", res?.message);
          LIST_API();
          setIsModalOpen(false);
          setLoader(false);
          if (onSuccess) onSuccess();
          set_errors({});
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          setLoader(false);
        }
      });
    } catch (error) {
      setLoader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = (data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.edit_view_lng_cargo_compressor_details, FORM_DATA).then((res) => {
        if (res?.status === true) {
          setResponseData(res?.lng_cargo_parameters_data);
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          setLoader(false);
        }
      });
    } catch (error) {
      console.error("Error while viewing LNG Cargo Compressor details", error);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>LNG Cargo Compressor Information</h3>
      <Button
        type="primary"
        onClick={() => {
          setIsModalOpen(true);
          setResponseData({});
        }}
        style={{ position: "absolute", right: "0px", top: "-10px" }}
      >
        Add LNG Cargo Compressor
      </Button>
      <AddLngCargoCompressorModal
        visible={isModalOpen}
        onOk={(data) => {
          if (responseData?.id) {
            UPDATE_API({ ...data, id: responseData.id });
          } else {
            ADD_API(data);
          }
        }}
        onCancel={() => {
          setIsModalOpen(false);
          setResponseData({});
          set_errors({});
        }}
        responseData={responseData}
        errors={errors}
      />
      {loader ? (
        <SisLoader />
      ) : (
        <>
          {filteredData?.length > 0 ? (
            <LngCargoCompressorTable data={filteredData} onEdit={(row) => VIEW_API(row)} />
          ) : (
            "No data available"
          )}
        </>
      )}
    </div>
  );
}

export default LngCargoCompressor;
